import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TestsPage } from "@/features/tests/TestsPage";
import { testsQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

const search = projectSearch.extend({
  tab: z.enum(["tests", "coverage"]).optional(),
  status: z.enum(["all", "failed", "fail", "warn", "pass", "muted"]).optional(),
  flaky: z.boolean().optional(),
});

export const Route = createFileRoute("/w/$workspace/p/$project/tests")({
  validateSearch: search,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(testsQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const s = Route.useSearch();
    const navigate = Route.useNavigate();
    const status = s.status === "failed" ? "fail" : (s.status ?? "all");
    return (
      <TestsPage
        workspace={workspace}
        project={project}
        env={s.env ?? DEFAULT_ENV}
        tab={s.tab ?? "tests"}
        status={status}
        flaky={s.flaky ?? false}
        onSearch={(patch) =>
          navigate({
            search: (prev) => ({
              env: prev.env,
              tab: (patch.tab ?? prev.tab) === "tests" ? undefined : (patch.tab ?? prev.tab),
              status:
                (patch.status ?? prev.status) === "all" ? undefined : (patch.status ?? prev.status),
              flaky: (patch.flaky ?? prev.flaky) ? true : undefined,
            }),
            replace: true,
          })
        }
      />
    );
  },
});
